export const ESCROWTAB_COMPANY_ID = 'fe2b4cfb-0009-4b55-a406-b9246b90c0eb';
